import { useCallback, useState } from 'react';
import {
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

import type { DragEndEvent, DragStartEvent } from '@dnd-kit/core';

type UseRackDndProps = {
  onSwap: (sourceSeq: number, targetSeq: number) => void;
};

export const useRackDnd = ({ onSwap }: UseRackDndProps) => {
  const [activeId, setActiveId] = useState<number | null>(null);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8
      }
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 5
      }
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );

  const handleDragStart = useCallback((event: DragStartEvent) => {
    setActiveId(Number(event.active.id));
  }, []);

  const handleDragEnd = useCallback(
    (event: DragEndEvent) => {
      const { active, over } = event;
      setActiveId(null);

      if (!over || active.id === over.id) return;

      onSwap(Number(active.id), Number(over.id));
    },
    [onSwap]
  );

  return {
    sensors,
    activeId,
    collisionDetection: closestCenter,
    handleDragStart,
    handleDragEnd
  };
};
